import { render, staticRenderFns } from "./SourceValueNotice.vue?vue&type=template&id=1fa0d5e8&scoped=true"
import script from "./SourceValueNotice.vue?vue&type=script&lang=js"
export * from "./SourceValueNotice.vue?vue&type=script&lang=js"
import style0 from "./SourceValueNotice.vue?vue&type=style&index=0&id=1fa0d5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0d5e8",
  null
  
)

export default component.exports